import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { all_routes } from "Router/all_routes";
import { Link, useSearchParams } from "react-router-dom";
import { useTableSearch } from "core/Operations/useTableSearch";
import Error404 from "MainPages/ErrorPages/error404";
import { useForm, FormProvider, Controller } from "react-hook-form";
import { loggedInUser } from "core/redux/slice/authSlice";
import { useSelector } from "react-redux";
import {
  addDays,
  endOfMonth,
  endOfWeek,
  format,
  startOfMonth,
  startOfWeek,
} from "date-fns";
import ToastNotification from "Components/UI/ToastNotification";
import { yupResolver } from "@hookform/resolvers/yup";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Attendance from "Components/Modal/attendance";
import { addSingleAttendaceValidationSchema } from "core/Operations/ValidationSchema/attendanceValidationSchema";
import { useAddAttendanceMutation } from "AppQuries/attendance/add-attendance";
import Select from "react-select";
import { DatePicker, message, Table } from "antd";
import { Download, PlusCircle, Upload } from "react-feather";
import moment from "moment";
import { useGetEmpAttendanceFilterQuery } from "AppQuries/attendance/get-emp-attendance-filter";
const { RangePicker } = DatePicker;
import useTableExport from "core/Operations/useTableExport";
import TableTop from "Components/UI/TableTop";
import dayjs from "dayjs";
import { getCurrentFormattedDate } from "core/Operations/currentDateTime";
import { toast } from "core/Operations/toast";

const attendanceTypeOptions = [
  {
    label: "Present",
    value: "Present",
  },
  {
    label: "Absent",
    value: "Absent",
  },
  {
    label: "Half Day",
    value: "Half Day",
  },
];
const filterTypeOptions = [
  {
    label: "Today",
    value: "Today",
  },
  {
    label: "Week",
    value: "Week",
  },
  {
    label: "Month",
    value: "Month",
  },
  {
    label: "Custom",
    value: "Custom",
  },
];

const disabled7DaysDate = (current, { from }) => {
  if (from) {
    return Math.abs(current.diff(from, "days")) >= 90;
  }
  return false;
};

const AttendanceFilter = () => {
  const userData = useSelector(loggedInUser);
  const allowedMenus = userData?.access?.map((access) => access.menuName);
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedAttendanceType, setSelectedAttendanceType] = useState(
    searchParams.get("status") ?? "",
  );
  const [isMount, setIsMount] = useState(false);
  const [departmentFilter, setDepartmentFilter] = useState(null);
  const [designationFilter, setDesignationFilter] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [selectedFilterType, setSelectedFilterType] = useState("Today");
  const [attendanceFilterDate, setAttendanceFilterDate] = useState({
    fromDate: format(new Date(), "yyyy-MM-dd"),
    toDate: format(new Date(), "yyyy-MM-dd"),
  });

  const {
    data: attendanceData,
    isLoading,
    isFetching,
    isError,
    error,
    refetch: fetchAttendance,
  } = useGetEmpAttendanceFilterQuery({
    ...attendanceFilterDate,
    status: selectedAttendanceType,
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    userId: userData?.userID,
    isAllCompanies: userData?.isAllCompanies,
    selectedCompanyCode: userData?.selectedCompanyCode,
  });
  const methods = useForm({
    defaultValues: {
      companyCode: userData.companyCode,
      locationCode: userData.locationCode,
      attendanceDate: format(new Date(), "yyyy-MM-dd"),
      attendanceValue: 1,
      inTime: userData?.companyOpenTime,
      outTime: userData?.companyCloseTime,
    },
    resolver: yupResolver(addSingleAttendaceValidationSchema),
  });

  const { mutate: addAttendance } = useAddAttendanceMutation();

  const [selectedDesignation, setSelectedDesignation] = useState(null);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  // const getDynamicColumns = (attendanceDetails) => {
  //   return Array.isArray(attendanceDetails)
  //     ? attendanceDetails.map((detail) => {
  //         const date = moment(detail.attendaceDate).format("YYYY-MM-DD");
  //         const day = moment(detail.attendaceDate).format("dddd");

  //         return {
  //           title: (
  //             <div>
  //               <div>{date}</div>
  //               <div style={{ fontSize: "12px", color: "#888" }}>{day}</div>
  //             </div>
  //           ),
  //           children: [
  //             {
  //               title: "In Time",
  //               key: `${date}_inTime`,
  //               dataIndex: "inTime",
  //               // render: () =>
  //               //   `${detail.inTime.value.hours}:${detail.inTime.value.minutes
  //               //     .toString()
  //               //     .padStart(2, "0")} AM`,
  //               render: () => detail.inTime === '00:00:00' ? " - " : moment(detail.inTime, ["HH:mm"]).format("hh:mm A")
  //             },
  //             {
  //               title: "Out Time",
  //               key: `${date}_outTime`,
  //               dataIndex: "outTime",
  //               // render: () =>
  //               //   `${
  //               //     detail.outTime.value.hours > 12
  //               //       ? detail.outTime.value.hours - 12
  //               //       : detail.outTime.value.hours
  //               //   }:${detail.outTime.value.minutes
  //               //     .toString()
  //               //     .padStart(2, "0")} ${
  //               //     detail.outTime.value.hours >= 12 ? "PM" : "AM"
  //               //   }`,
  //               render : () => detail.outTime === '00:00:00' ? " - " : moment(detail.outTime, ["HH:mm"]).format("hh:mm A")
  //             },
  //             {
  //               title: "Status",
  //               key: `${date}_status`,
  //               dataIndex: ["attendanceDetails", 0, "status"],
  //               render: (text, record) => (
  //                 <span
  //                   className={`badge rounded-pill ${
  //                     text === "OnTime"
  //                       ? "bg-outline-success"
  //                       : "bg-outline-danger"
  //                   }`}
  //                 >
  //                   {text}
  //                 </span>
  //               ),
  //             },
  //             {
  //               title: "Started Early",
  //               key: `${date}_startedEarly`,
  //               dataIndex: ["attendanceDetails", 0, "startedEarly"],
  //             },
  //             {
  //               title: "Finished Late",
  //               key: `${date}_finishedLate`,
  //               dataIndex: ["attendanceDetails", 0, "finishedLate"],
  //             },
  //           ],
  //         };
  //       })
  //     : [];
  // };

  const attendanceFilterHandler = (e) => {
    setSelectedFilterType(e.value || "Today");

    const currentDate = format(new Date(), "yyyy-MM-dd");

    switch (e.value) {
      case "Today":
        setAttendanceFilterDate({
          fromDate: format(new Date(), "yyyy-MM-dd"),
          toDate: format(new Date(), "yyyy-MM-dd"),
        });
        break;
      case "Week":
        // 1 day added for date start with monday
        setAttendanceFilterDate({
          fromDate: format(addDays(startOfWeek(currentDate), 1), "yyyy-MM-dd"),
          toDate: format(addDays(endOfWeek(currentDate), 1), "yyyy-MM-dd"),
        });
        break;
      case "Month":
        setAttendanceFilterDate({
          fromDate: format(startOfMonth(currentDate), "yyyy-MM-dd"),
          toDate: format(endOfMonth(currentDate), "yyyy-MM-dd"),
        });
        break;
      case "Custom":
        break;
      default:
        setAttendanceFilterDate({
          fromDate: format(new Date(), "yyyy-MM-dd"),
          toDate: format(new Date(), "yyyy-MM-dd"),
        });
        break;
    }
  };

  const getDynamicColumns = (attendanceData) => {
    if (!Array.isArray(attendanceData)) return [];

    // Extract unique dates from attendance details
    const uniqueDates = [
      ...new Set(
        attendanceData.flatMap((employee) =>
          employee.attendanceDetails.map((detail) =>
            moment(detail.attendaceDate).format("YYYY-MM-DD"),
          ),
        ),
      ),
    ];

    // Generate dynamic columns for each date
    return uniqueDates.map((date) => {
      const day = moment(date).format("dddd");

      return {
        title: (
          <div>
            <div>{date}</div>
            <div style={{ fontSize: "12px", color: "#888" }}>{day}</div>
          </div>
        ),
        children: [
          {
            title: "In Time",
            key: `${date}_inTime`,
            dataIndex: "attendanceDetails",
            render: (details) => {
              const detail = details.find(
                (d) => moment(d.attendaceDate).format("YYYY-MM-DD") === date,
              );
              return detail?.inTime === "00:00:00"
                ? " - "
                : moment(detail?.inTime, ["HH:mm"]).format("hh:mm A");
            },
          },
          {
            title: "Out Time",
            key: `${date}_outTime`,
            dataIndex: "attendanceDetails",
            render: (details) => {
              const detail = details.find(
                (d) => moment(d.attendaceDate).format("YYYY-MM-DD") === date,
              );
              return detail?.outTime === "00:00:00"
                ? " - "
                : moment(detail?.outTime, ["HH:mm"]).format("hh:mm A");
            },
          },
          {
            title: "Status",
            key: `${date}_status`,
            dataIndex: "attendanceDetails",
            render: (details) => {
              const detail = details.find(
                (d) => moment(d.attendaceDate).format("YYYY-MM-DD") === date,
              );
              return (
                <span
                  className={`badge rounded-pill ${
                    detail?.status === "OnTime"
                      ? "bg-outline-success"
                      : "bg-outline-danger"
                  }`}
                >
                  {detail?.status || "-"}
                </span>
              );
            },
          },
          {
            title: "Started Early",
            key: `${date}_startedEarly`,
            dataIndex: "attendanceDetails",
            render: (details) => {
              const detail = details.find(
                (d) => moment(d.attendaceDate).format("YYYY-MM-DD") === date,
              );
              return detail?.startedEarly || "-";
            },
          },
          {
            title: "Finished Late",
            key: `${date}_finishedLate`,
            dataIndex: "attendanceDetails",
            render: (details) => {
              const detail = details.find(
                (d) => moment(d.attendaceDate).format("YYYY-MM-DD") === date,
              );
              return detail?.finishedLate || "-";
            },
          },
          {
            title: "Check-in Method",
            key: `${date}_checkinMethod`,
            dataIndex: "attendanceDetails",
            render: (details) => {
              const detail = details.find(
                (d) => moment(d.attendaceDate).format("YYYY-MM-DD") === date,
              );
              return detail?.checkinMethod || "-";
            },
          },
          {
            title: "Login Location",
            key: `${date}_loginLocation`,
            dataIndex: "attendanceDetails",
            render: (details) => {
              const detail = details.find(
                (d) => moment(d.attendaceDate).format("YYYY-MM-DD") === date,
              );
              return detail?.loginLocation || "-";
            },
          },
          {
            title: "Logout Location",
            key: `${date}_logoutLocation`,
            dataIndex: "attendanceDetails",
            render: (details) => {
              const detail = details.find(
                (d) => moment(d.attendaceDate).format("YYYY-MM-DD") === date,
              );
              return detail?.logoutLocation || "-";
            },
          },
        ],
      };
    });
  };

  const fixedColumns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueID",
      key: "uniqueID",
    },
    {
      title: "Emp Name",
      dataIndex: "fullName",
      key: "fullName",
      fixed: "left",
      width: 200,
    },
    {
      title: "Department",
      dataIndex: "departmentName",
      key: "departmentName",
      //   fixed: "left",
      //   width: 200,
      // filters: attendanceData?.map((d) => ({
      //   text: d?.departmentName,
      //   value: d?.departmentName,
      // })),
      // filters: attendanceData
      //   ?.map((d) => ({
      //     text: d?.departmentName,
      //     value: d?.departmentName,
      //   }))
      //   .filter(
      //     (o, index, arr) =>
      //       arr.findIndex(
      //         (item) => JSON.stringify(item) === JSON.stringify(o)
      //       ) === index
      //   ),
      // onFilter: (value, record) => record.departmentName.indexOf(value) === 0,
      filters: Array.from(
        new Set(attendanceData?.map((d) => d?.departmentName).filter(Boolean)),
      ).map((name) => ({ text: name, value: name })),
      onFilter: (value, record) => record.departmentName?.startsWith(value),
    },
    {
      title: "Designation",
      dataIndex: "designationName",
      key: "designationName",
      filters: Array.from(
        new Set(attendanceData?.map((d) => d?.designationName).filter(Boolean)),
      ).map((name) => ({ text: name, value: name })),
      onFilter: (value, record) => record.designationName?.startsWith(value),
    },
  ];

  const dynamicColumns = getDynamicColumns(attendanceData);
  const columns = [...fixedColumns, ...dynamicColumns];

  // const filteredData = attendanceData?.filter((item) => {
  //   const matchesDepartment = departmentFilter
  //     ? item.departmentName === departmentFilter
  //     : true;
  //   const matchesDesignation = designationFilter
  //     ? item.designationName === designationFilter
  //     : true;
  //   const matchesSearch = item.fullName
  //     .toLowerCase()
  //     .includes(searchText.toLowerCase());

  //   return matchesDepartment && matchesDesignation && matchesSearch;
  // });

  const handleAddClick = () => {
    setSelectedDesignation(null);
    methods.reset({
      companyCode: userData.companyCode,
      locationCode: userData.locationCode,
      description: "",
      isActive: 1,
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS",
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS",
      )}Z`,
    });
    setShow(true);
  };

  const onSubmit = async (payload) => {
    const attendanceData = {
      companyCode: 1,
      attendanceDate: payload.attendanceDate,
      locationCode: payload.locationCode,
      attendance: [
        {
          employeeCode: Number(payload.employeeCode),
          attendanceValue: Number(payload.attendanceValue),
          inTime: payload.inTime,
          outTime: payload.outTime,
          createUser: userData.userName,
          createDate: getCurrentFormattedDate(),
          modifyUser: userData.userName,
          modifyDate: getCurrentFormattedDate(),
          scheduleId: payload.scheduleId ?? 0,
          projectCode: "",
          remarks: "",
          mode: "MM",
          waitingTime: "00:00:00",
          wtrot: "00:00:00",
          oT1: 0,
          oT2: 0,
          extraCharge: 0,
          isApproved: false,
          wtnhEdit: true,
          supplierCompany: "",
          service: "",
          isReviewed: false,
          reviewDate: "",
          reviewBy: "",
          approvedDate: "",
          approvedBy: "",
          haveSplit: false,
        },
      ],
    };

    addAttendance(attendanceData, {
      onSuccess: (data) => {
        if (data[0].response === true) {
          toast.success("Attendance Saved Successfully.");
          setSelectedDesignation(null);
          setShow(false);
          fetchAttendance();
        } else {
          toast.warning(data[0].errorMessage);
        }
      },
      onError: (error) => {
        toast.warning(error.message || "Something went wrong.");
      },
    });
  };

  const transformDataForExport = (data) => {
    return data?.map((row) => {
      return {
        ...row,
        // Handle complex fields here
        inTime: row.inTime ? `${row.inTime.hours}:${row.inTime.minutes}` : "",
        outTime: row.outTime
          ? `${
              row.outTime.hours > 12
                ? row.outTime.hours - 12
                : row.outTime.hours
            }:${row.outTime.minutes} ${row.outTime.hours >= 12 ? "PM" : "AM"}`
          : "",
        attendanceStatus: row.attendanceDetails?.[0]?.status || "",
        startedEarly: row.attendanceDetails?.[0]?.startedEarly || "",
        finishedLate: row.attendanceDetails?.[0]?.finishedLate || "",
      };
    });
  };

  // const getDynamicColumns = (attendanceDetails) => {
  //   return Array.isArray(attendanceDetails)
  //     ? attendanceDetails.map((detail) => {
  //         const date = moment(detail.attendaceDate).format("YYYY-MM-DD");
  //         return {
  //           title: `${date}`,
  //           key: date,
  //           render: (text, record) => `${detail.inTime?.hours}:${detail.inTime?.minutes}`,
  //         };
  //       })
  //     : [];
  // };

  const flattenDataForExport = (data, columns) => {
    return data?.map((row) => {
      const flattenedRow = { ...row };

      columns.forEach((column) => {
        if (column.children) {
          column.children.forEach((child) => {
            const key = child.key;

            // Handle nested dataIndex fields
            if (Array.isArray(child.dataIndex)) {
              let value = row;
              child.dataIndex.forEach((index) => {
                value = value ? value[index] : "";
              });
              flattenedRow[key] = value;
            }
          });
        }
      });

      return flattenedRow;
    });
  };

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    attendanceData,
    searchColumns,
  );

  const { onAttendanceExcelDownload } = useTableExport({
    columns: columns,
    data: flattenDataForExport(filteredData, columns),
    fileName: `${attendanceFilterDate.fromDate} - ${attendanceFilterDate.toDate} Attendance Data`,
    pdfTheme: "",
  });

  useEffect(() => {
    // if (isMount) {
    fetchAttendance();
    // }
    // setIsMount(true);
  }, [attendanceFilterDate, selectedAttendanceType]);

  if (isLoading || isFetching) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Attendance Summary</h4>
                <h6>Manage your employees attendance</h6>
              </div>
            </div>
            <div className="page-btn">
              <Select
                options={attendanceTypeOptions}
                placeholder="Select Attendance Type"
                className={`select`}
                value={attendanceTypeOptions.find(
                  (option) => option.value === selectedAttendanceType,
                )}
                onChange={(e) => setSelectedAttendanceType(e?.value)}
                menuPortalTarget={document.body}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    width: "200px",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
              />
            </div>
            <div className="page-btn">
              <Select
                options={filterTypeOptions}
                placeholder="Select Filter Type"
                className={`select`}
                value={filterTypeOptions.find(
                  (option) => option.value === selectedFilterType,
                )}
                onChange={attendanceFilterHandler}
                menuPortalTarget={document.body}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    width: "200px",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
              />
            </div>
            {selectedFilterType === "Custom" && (
              <div className="page-btn">
                <RangePicker
                  disabledDate={disabled7DaysDate}
                  className="form-control"
                  style={{ display: "flex" }}
                  onChange={(date, dateFormat) => {
                    setAttendanceFilterDate({
                      fromDate:
                        dateFormat[0] || format(new Date(), "yyyy-MM-dd"),
                      toDate: dateFormat[1] || format(new Date(), "yyyy-MM-dd"),
                    });
                  }}
                  defaultValue={[
                    dayjs(attendanceFilterDate.fromDate, "YYYY-MM-DD"),
                    dayjs(attendanceFilterDate.toDate, "YYYY-MM-DD"),
                  ]}
                  // format="DD-MM-YYYY"
                />
              </div>
            )}
            {/* {allowedMenus.includes("Add Attendance") && (
              <div className="page-btn">
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="add-new-tooltip">Add Attendance</Tooltip>
                  }
                >
                  <Link
                    to="#"
                    className="btn btn-added"
                    onClick={handleAddClick}
                  >
                    <PlusCircle className="me-2" />
                    Add Attendance
                  </Link>
                </OverlayTrigger>
              </div>
            )} */}
            {/* {allowedMenus.includes("Monthly Attendance") && ( */}
            {/* <div className="page-btn">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="add-new-tooltip">Monthly Attendance</Tooltip>
                }
              >
                <Link
                  to={`${all_routes.attendance}${all_routes.attendance_month}`}
                  className="btn btn-added"
                >
                  <PlusCircle className="me-2" />
                  Monthly Attendance
                </Link>
              </OverlayTrigger>
            </div> */}
            {/* )} */}
            {/* {allowedMenus.includes("Import Attendance") && (
              <div className="page-btn">
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="add-new-tooltip">Import Attendance</Tooltip>
                  }
                >
                  <Link
                    to={`${all_routes.attendance}${all_routes.attendance_import}`}
                    className="btn btn-secondary"
                  >
                    <Download className="me-2" />
                    Import
                  </Link>
                </OverlayTrigger>
              </div>
            )} */}
            <div className="page-btn">
              <button
                className="btn btn-defalut"
                type="button"
                onClick={onAttendanceExcelDownload}
              >
                <Upload className="me-2" />
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="table-list-card mt-2">
                <TableTop
                  onSearch={setSearchValue}
                  toggleFilterVisibility={toggleFilterVisibility}
                  showToggle={false}
                  isFilterVisible={isFilterVisible}
                />
                <div className="table-responsive">
                  <Table
                    className="table datanew"
                    columns={columns}
                    dataSource={filteredData}
                    pagination={true}
                    rowKey={(record) => record.employeeCode}
                    // size="small"
                    // scroll={{ x: 1300 }}

                    // scroll={{ y: 500 }}
                    //     scroll={{
                    //   x: 1300,
                    //   y: 500, // Enables sticky header
                    // }}
                    expandable={{
                      expandIconColumnIndex: 0, // 👈 shows expand button near first column (Emp Code)

                      expandedRowRender: (record) => {
                        return (
                          <div style={{ padding: "10px 20px" }}>
                            {record.attendanceDetails.map(
                              (attendance, index) => (
                                <div key={index} style={{ marginBottom: 15 }}>
                                  <b>
                                    {moment(attendance.attendaceDate).format(
                                      "YYYY-MM-DD",
                                    )}
                                  </b>

                                  <table
                                    style={{
                                      width: "auto",
                                      marginTop: 8,
                                      borderCollapse: "collapse",
                                    }}
                                    className="table table-bordered table-stripped text-center"
                                  >
                                    <thead>
                                      <tr>
                                        <th>Break In</th>
                                        <th>Break Out</th>
                                        <th>Break Hours</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {attendance?.breakDetails?.length > 0 &&
                                        attendance.breakDetails?.map(
                                          (breakItem, i) => (
                                            <tr key={i}>
                                              <td>
                                                {moment(
                                                  breakItem.breakInTime,
                                                  "HH:mm",
                                                ).format("hh:mm A")}
                                              </td>
                                              <td>
                                                {breakItem.breakOutTime !== "-"
                                                  ? moment(
                                                      breakItem.breakOutTime,
                                                      "HH:mm",
                                                    ).format("hh:mm A")
                                                  : "-"}
                                              </td>
                                              <td>{breakItem.breakHours}</td>
                                            </tr>
                                          ),
                                        )}
                                    </tbody>
                                  </table>
                                </div>
                              ),
                            )}
                          </div>
                        );
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FormProvider {...methods}>
        <Attendance
          mode={selectedDesignation ? "E" : "I"}
          onSubmit={onSubmit}
          show={show}
          handleClose={handleClose}
        />
      </FormProvider>
    </div>
  );
};
export default AttendanceFilter;
